import { FC } from 'react';
import { NavTab } from 'types/baseTypes';
import OverlayedNavTab from './OverlayedNavTab';

interface OverlayedNavSectionProps {
  isBottomBar?: boolean;
  navList: NavTab[];
  onNavTabClick: (tab: NavTab) => void;
  activeTab: NavTab;
  className?: string;
  onSubTabClick: (tab: NavTab) => void;
}

const OverlayedNavSection: FC<OverlayedNavSectionProps> = ({
  isBottomBar = false,
  navList,
  onNavTabClick,
  activeTab,
  className,
  onSubTabClick
}) => {
  return (
    <div className={`${className} space-y-2 pt-5 pb-7`}>
      {navList.map(tab => {
        return (
          <div key={tab.key}>
            <OverlayedNavTab
              tab={tab}
              onNavTabClick={onNavTabClick}
              isBottomBar={isBottomBar}
              activeTab={activeTab}
              key={tab.key}
            />
            {tab?.hasChildTabs &&
              activeTab.key === tab.key &&
              tab.childTabs.map((subTab, index) => (
                <div key={subTab.key + index}>
                  <OverlayedNavTab
                    tab={subTab}
                    onNavTabClick={onSubTabClick}
                    isBottomBar={isBottomBar}
                    activeTab={activeTab}
                    subTabClassname="pl-10"
                  />
                </div>
              ))}
          </div>
        );
      })}
    </div>
  );
};

export default OverlayedNavSection;
